import React, { useContext } from 'react';

import { PresetButtonItem, PresetButtons } from '@/components/PresetButtons';
import { TooltipStatic } from '@/components/Profile/ProfileMembership/TooltipStatic';
import { useMembershipTabContainer } from '@/components/Profile/ProfileMembership/useMembershipTabContainer';
import { SubscriptionCard } from '@/components/SubscriptionCard/SubscriptionCard';
import { SUBSCRIPTION_PLANS_CONFIG } from '@/components/SubscriptionCard/SubscriptionCard.utils';
import { EditProfileContext } from '@/contexts/EditProfileProvider';
import useMediaQuery from '@/Utils/useMediaQuery';

export const presetButtons: PresetButtonItem[] = [
  { label: 'Monthly', value: 'monthly' },
  { label: 'Yearly', value: 'yearly' },
];

const ProfileMembership = () => {
  const { selectedBillingFrequencyButton, setSelectedBillingFrequencyButton } =
    useContext(EditProfileContext);

  const isMobile = useMediaQuery('(max-width: 768px)');

  useMembershipTabContainer({ isMobile });

  return (
    <>
      <div className='mt-24 flex justify-center billing-frequency'>
        <div className='relative'>
          {PresetButtons({
            buttons: presetButtons,
            onSelect: (button) => {
              setSelectedBillingFrequencyButton(button);
            },
            selectedButton: selectedBillingFrequencyButton,
          })}

          <TooltipStatic withArrow={!isMobile} />
        </div>
      </div>

      <div
        className={`flex ${isMobile ? 'flex-col' : 'overflow-x-auto my-20'} gap-5 pb-32 membership-tab pt-4`}
      >
        {Object.keys(SUBSCRIPTION_PLANS_CONFIG).map((plan) => (
          <SubscriptionCard
            key={plan}
            plan={plan as keyof typeof SUBSCRIPTION_PLANS_CONFIG}
          />
        ))}
      </div>
    </>
  );
};

export default ProfileMembership;
